/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=60074f0c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60074f0c"]])

export default __exports__